const urls = {
  getValidClasses: '/ppt-plugin/courses/classes/valid',
  startProxyAttendance: '/classes/attendance/proxy/start',
  stopProxyAttendance: '/classes/attendance/proxy/stop',
  getAttendanceResponders: '/classes/attendance/responders',
  getValidAttendanceData: '/ppt-plugin/courses/classes/valid/attendance',
} as const;

export default urls;
